// polyfill to make scrollToElement function work also in IE11, Edge and Safari
import smoothScroll from 'smoothscroll-polyfill';
smoothScroll.polyfill();

export function checkIfDesktop() {
    return window.innerWidth >= 1000;
}

export function checkIfTablet() {
    return window.innerWidth > 700;
}

export function getRadians(degrees) {
    return degrees * Math.PI / 180;
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function camelize(object) {
    let newObject, origKey, newKey, value;
    if (object instanceof Array) {
        return object.map(function(value) {
            if (typeof value === "object") {
                value = camelize(value)
            }
            return value;
        })
    } else {
        newObject = {};
        for (origKey in object) {
            if (object.hasOwnProperty(origKey)) {
                newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                value = object[origKey];
                if (value instanceof Array || (value !== null && value.constructor === Object)) {
                    value = camelize(value)
                }
                newObject[newKey] = value
            }
        }
    }
    return newObject
}

export function scrollToElement(element) {
    const elementYOffsetFromTheViewport = element.getBoundingClientRect().top;
    const windowYOffset = window.pageYOffset;
    const amountOfSpaceBeforeTheElement = 20; // in pixels
    const top = elementYOffsetFromTheViewport + windowYOffset - amountOfSpaceBeforeTheElement;

    window.scroll({top: top, behavior: 'smooth'});
}

export function triggerMouseEvent(node, eventType) {
    var clickEvent = document.createEvent('MouseEvents');
    clickEvent.initEvent(eventType, true, true);
    node.dispatchEvent(clickEvent);
}

/***** Cookies *****/
export function setCookie(name, val, days, path, domain, secure) {
    if (navigator.cookieEnabled) { // check if cookies are on
        const cookieName = encodeURIComponent(name);
        const cookieVal = encodeURIComponent(val);
        let cookieText = cookieName + '=' + cookieVal;

        if (typeof days === 'number') {
            const data = new Date();
            data.setTime(data.getTime() + (days * 24*60*60*1000));
            cookieText += '; expires=' + data.toGMTString();
        }

        if (path) {
            cookieText += '; path=' + path;
        }
        if (domain) {
            cookieText += '; domain=' + domain;
        }
        if (secure) {
            cookieText += '; secure';
        }

        document.cookie = cookieText;
    }
}

export function getCookie(name) {
    if (document.cookie !== '') {
        const cookies = document.cookie.split(/; */);

        for (let i=0; i<cookies.length; i++) {
            const cookieName = cookies[i].split('=')[0];
            const cookieVal = cookies[i].split('=')[1];
            if (cookieName === decodeURIComponent(name)) {
                return decodeURIComponent(cookieVal);
            }
        }
    }
}

export function deleteCookie(name) {
    const cookieName = encodeURIComponent(name);
    document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
/***** End Cookies *****/

export function addRecaptchaScript() {
    return new Promise((resolve) => {
      const scriptEl = document.getElementById('grecaptcha');
      if (scriptEl) return resolve(true);
 
      const script = document.createElement('script');
      script.src =
        `https://www.google.com/recaptcha/api.js?render=6LdF2H0oAAAAAO0YXBHwTHkaU1FjTK5Y55AvchBW`;
      script.setAttribute('id', 'grecaptcha');
      document.body.appendChild(script);
 
      script.addEventListener('load', function () {
        resolve(true);
      });
    });
};
 
export function getRecaptchaToken() {
    return new Promise((resolve) => {
        addRecaptchaScript().then(() => {
        resolve(
            new Promise((resolve) => {
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(`6LdF2H0oAAAAAO0YXBHwTHkaU1FjTK5Y55AvchBW`, {
                    action: 'submit',
                })
                .then(function (token) {
                    resolve(token);
                });
            });
            })
        );
        });
    });
}

export function checkRecaptcha() {
    const endpointUrl = '/api/recaptcha/isValid/';
    return new Promise((resolve) => {
        getRecaptchaToken().then((token) => {
        fetch(endpointUrl, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
            token: token,
            }),
        })
            .then((res) => res.json())
            .then((res) => resolve(res));
        });
    });
}

export function debounce(callback, delay) {
    let timer;
    return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => callback(...args), delay)
    }
}